import React from 'react'
import styled from 'styled-components'
import { useLanguageState } from '../../globalStates/LanguageState'

const Wrapper = styled.div`
    display: inline-flex;
    white-space: break-spaces;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
`

const Count = styled.div<{ mainColor: string }>`
    color: ${props => props.mainColor || "#6DD400"};
`

interface CounterProps {
    count: string
    limit?: string
    isCountable?: boolean
    showCounter?: boolean
}

const Counter: React.FC<CounterProps> = ({ count, limit, isCountable = false, showCounter = false }) => {
    const branding = useLanguageState().getStrings()
    return (
        <Wrapper>
            {branding.configuration.pageCounter}
            <Count mainColor={branding.configuration.maincolor}>{`(${count})`}</Count>
            {branding.configuration.pageCounterMiddle}
            {(isCountable || showCounter) ? limit : "no limit"}
        </Wrapper>
    )
}

export default Counter